export type ButtonSize = 'sm' | 'md' | 'lg'

const BASE =
  'group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-[8px] bg-orange text-center font-heading font-bold uppercase tracking-[0.06em] text-charcoal shadow-[inset_0_1px_0_rgba(255,255,255,0.35),0_14px_28px_-14px_rgba(244,122,38,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-orange-light active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-arc/60'

const SIZES: Record<ButtonSize, string> = {
  sm: 'min-h-[46px] px-4 text-[1rem]',
  md: 'min-h-[52px] px-6 text-[1.08rem]',
  lg: 'min-h-[58px] px-5 text-[1.08rem] sm:px-8 sm:text-[1.2rem]',
}

/** Primary orange button classes, shared by purchase and scroll CTAs. */
export function primaryButtonClass(size: ButtonSize = 'md'): string {
  return `${BASE} ${SIZES[size]}`
}
